import React from "react";
import img1 from "../../../Images/bg-1.jpg";
import img from "../../../Images/my.png";
import { Parallax } from "react-parallax";
import Particles from "react-tsparticles";
import { Box, Grid } from "@mui/material";
import "./Banner.css";
import Download from "@mui/icons-material/Download";

const Banner = () => {
  return (
    <div div className="parallax-container1">
      <Parallax
        bgImage={img1}
        bgImageStyle={{
          height: "800px",
          width: "100%",
          opacity: "1",
          objectFit: "cover",
        }}
        strength={600}
        className="parallax-container"
      >
        <Grid container spacing={2} style={{ zIndex: 0, position: "absolute" }}>
          <Grid item md={6} sx={12} sm={6}>
            <Box className="banner-info">
              <p className="banner-name">Hello , My name is</p>

              <p className="banner-name my-name" variant="h2">
                Ashraful islam
              </p>
              <h2 className="profession">Full-stack web developer</h2>
              <p className="about-me">
                I design and develop services for customers of all sizes,
                specializing in creating stylish, modern websites, web services
                and online stores.
              </p>
              <button className="download-resume">
                <Download style={{ marginBottom: -8 }} />
                <a
                  href="https://drive.google.com/file/d/1B7OC-f9BZ2QnQZITWS9SGeKgWVGDZ4gF/view?usp=sharing"
                  target="_blank"
                  rel="noreferrer"
                >
                  {" "}
                  Download Resume
                </a>
              </button>
            </Box>
          </Grid>
          <Grid item md={6} sx={12} sm={6}>
            <img src={img} className="my-photo" alt="" />
          </Grid>
        </Grid>

        <Particles
          options={{
            fullScreen: {
              enable: false,
              zIndex: 1000,
            },
            fpsLimit: 20,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "push",
                },
                onHover: {
                  enable: true,
                  mode: "bubble",
                },
                resize: true,
              },
              modes: {
                bubble: {
                  distance: 50,
                  duration: 2,
                  opacity: 1,
                  size: 10,
                  color: {
                    value: "random",
                  },
                },
                push: {
                  quantity: 3,
                },
                repulse: {
                  distance: 200,
                  duration: 0.4,
                },
              },
            },
            particles: {
              // frequency	:	5,
              color: {
                value: "random",
                // value: "#4600b0",
              },
              links: {
                color: "#ffffff",
                distance: 1,
                enable: true,
                opacity: 0.5,
                width: 10,
              },
              collisions: {
                enable: false,
              },
              move: {
                direction: "bottom",
                enable: true,
                //   outMode: "bounce",
                random: true,
                speed: 2,
                // straight: true,
              },
              number: {
                density: {
                  enable: true,
                  area: 1000,
                },
                value: 80,
              },
              opacity: {
                value: 0.5,
              },
              shape: {
                type: "star",
              },
              size: {
                random: true,
                value: 6,
              },
            },
            detectRetina: false,
          }}
        />
      </Parallax>
    </div>
  );
};

export default Banner;
